<template>
  <div class="assessment-wizard-container">
    <!-- Loading Screen -->
    <div class="assessment-loading-container">
      <div class="loading-content">
        <div class="loading-header">
          <div class="spinner-wrapper">
            <i class="fa fa-circle-o-notch fa-spin loading-spinner" />
          </div>
          <p class="loading-title">
            {{ mainMessage }}
          </p>
        </div>
        <div class="loading-steps">
          <p
            v-for="(step, index) in progressSteps"
            :key="index"
            class="loading-step">
            {{ step }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'AssessmentLoadingScreen',
  emits: ['return-to-wizard'],
  computed: {
    ...mapGetters({
      events: 'agenticSearch/events',
      loading: 'agenticSearch/loading',
      currentPhase: 'agenticSearch/currentPhase',
    }),
    mainMessage() {
      return 'Searching 17,000+ assessments for the best matches...'
    },
    progressSteps() {
      const phase = this.currentPhase ?? 0
      const steps = [
        'Searching through our catalog of 17,000+ assessments...',
        'Filtering by grade level and subject...',
        'Ranking results by relevance...'
      ]
      // Show steps up to and including the current phase
      return steps.slice(0, phase + 1)
    },
  },
}
</script>

<style lang="less" scoped>
@import '@/variables.less';

.assessment-wizard-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  padding: 0;
  max-width: 565.625px;
  margin: 0 auto;
}

.assessment-loading-container {
  background: @ai-gradient;
  border-radius: 8px;
  padding: 1px;
  width: 100%;
  flex-shrink: 0;
}

.loading-content {
  background-color: #f5f5f5;
  border-radius: 7px;
  padding: 41px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.loading-header {
  display: flex;
  align-items: center;
  gap: 10px;
}

.spinner-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  flex-shrink: 0;
}

.loading-spinner {
  font-size: 24px;
  color: #007dba;
}

.loading-title {
  margin: 0;
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  color: #333;
}

.loading-steps {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.loading-step {
  margin: 0;
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #6f6f6f;
}
</style>
